import React from 'react';
import { Card, Row, Col, Image, Button } from 'react-bootstrap';
import { Usuario } from '../Usuarios/Usuario';

export const MiPaciente = (props) => {
	/* Destructuring the props object. */
	const {
		fotoUsuario,
		nombreUsuario,
		idPaciente,
		direccionUsuario,
		telefonoUsuario,
		codPostUsuario,
		dni,
		abrirPerfil,
		Modo,
		estado,
		cambiarEstado,
		borrarPaciente,
		fotoPaciente,
	} = props;

	return (
	// 	<div
	// 		className={
	// 			'MiPaciente' /*
    //         ((estado === true) && (Modo === "normal"))
    //             ? "MiPaciente"
    //             : ((estado === false) && (Modo === "noNormal"))
    //                 ? "MiPaciente paraBorrar"
    //                 : ((estado === true) && (Modo === "noNormal"))
    //                     ? "MiPaciente selecionarPaciente"
    //                     : null
    // */
	// 		}
	// 		onClick={() => {
	// 			if (Modo === 'noNormal') {
	// 				cambiarEstado(idPaciente);
	// 			}
	// 		}}
	// 	>
	// 		<div className='fotoUsuario centrador'>
	// 			<div className='fotoNombreUsuario'>
	// 				<img src={fotoPaciente} />
	// 			</div>
	// 			<div className='nombreIdUsuario '>
	// 				<div className='nombreUsuario'>{nombreUsuario}</div>
	// 				{/*<div className='idUsuario'><b>ID : </b>{idPaciente}</div>*/}
	// 			</div>
	// 		</div>
	// 		<div className='datosUsuario'>
	// 			<div className='direccionUsuario'>
	// 				<b>Dirección : </b>
	// 				{direccionUsuario}
	// 			</div>
	// 			<div className='telefonoUsuario'>
	// 				<b>Teléfono : </b>
	// 				{telefonoUsuario}
	// 			</div>
	// 		</div>
	// 		<div className='datosUsuario'>
	// 			<div className='correoUsuario'>
	// 				<b>Cod. postal : </b>
	// 				{codPostUsuario}
	// 			</div>
	// 			<div className='telefonoUsuario'>
	// 				<b>DNI : </b>
	// 				{dni}
	// 			</div>
	// 		</div>
	// 		<div className='opciones-MisPaciente'>
	// 			<div
	// 				className='opcionRespuesta respuestaObligatoria'
	// 				onClick={() => {
	// 					if (Modo === 'normal') {
	// 						abrirPerfil(idPaciente);
	// 					}
	// 				}}
	// 			>
	// 				<div className='centrador'>
	// 					<svg
	// 						xmlns='http://www.w3.org/2000/svg'
	// 						width='24'
	// 						height='24'
	// 						fill='currentColor'
	// 						className='bi bi-pencil-square'
	// 						viewBox='0 0 16 16'
	// 					>
	// 						<path d='M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z' />
	// 						<path
	// 							fillRule='evenodd'
	// 							d='M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z'
	// 						/>
	// 					</svg>
	// 				</div>
	// 				<div className='centrador'>Modificar</div>
	// 			</div>
	// 			<div
	// 				className='opcionRespuesta eliminarRespuesta'
	// 				onClick={() => {
	// 					borrarPaciente(idPaciente);
	// 				}}
	// 			>
	// 				<div className='centrador'>
	// 					<svg
	// 						xmlns='http://www.w3.org/2000/svg'
	// 						width='24'
	// 						height='24'
	// 						fill='currentColor'
	// 						className='bi bi-trash'
	// 						viewBox='0 0 16 16'
	// 					>
	// 						<path d='M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z' />
	// 						<path
	// 							fillRule='evenodd'
	// 							d='M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z'
	// 						/>
	// 					</svg>
	// 				</div>
	// 				<div className='centrador'>Eliminar</div>
	// 			</div>
	// 		</div>
	// 	</div>
		<Card
			onClick={() => {
				if (Modo === 'noNormal') {
				cambiarEstado(idPaciente);
				}
			}}
			className={`mb-2 shadow-sm mt-2 ${
				Modo === 'noNormal' && estado === false
				? 'border-danger'
				: Modo === 'noNormal' && estado === true
				? 'border-primary'
				: ''
			}`}
			style={{
				cursor: Modo === 'noNormal' ? 'pointer' : 'default',
			}}
			>
			<Card.Body className="py-2 px-3">
				<Row className="align-items-center g-2">
				<Col xs="auto">
					<Image
					src={fotoPaciente || 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images'}
					roundedCircle
					style={{ width: '100px', height: 'auto', objectFit: 'cover' }}
					/>
				</Col>

				<Col xs={12} md>
					<div className="fw-semibold mb-1">{nombreUsuario !== Usuario.nombre ? nombreUsuario : 'Yo'}</div>
					<div className="text-muted small mb-1">
					<strong>Dirección:</strong> {direccionUsuario}
					</div>
					<div className="text-muted small mb-0">
					<strong>Teléfono:</strong> {telefonoUsuario}
					</div>
				</Col>

				<Col xs="auto" className="text-end">
					<Button
						className='outline-boton me-2'
						variant="outline-primary"
						size="sm"
						onClick={(e) => {
							e.stopPropagation();
							if (Modo === 'normal') {
							abrirPerfil(idPaciente);
							}
						}}
					>
					<i className="bi bi-pencil-square me-1"></i> Modificar
					</Button>
					<Button
						disabled={nombreUsuario === 'Yo'}
						variant="outline-danger"
						size="sm"
						onClick={(e) => {
							e.stopPropagation();
							borrarPaciente(idPaciente);
						}}
					>
					<i className="bi bi-trash me-1"></i> Eliminar
					</Button>
				</Col>
				</Row>
			</Card.Body>
			</Card>
	);
};
